import React from 'react';

type Props = {
  condition: boolean;
};

export const If: React.FC<React.PropsWithChildren<Props>> = ({ condition, children }) =>
  condition ? <>{children}</> : null;
